import React, { useState } from "react";
import { Sidebar } from "../../common/Sidebar";
import { Navbar } from "../../common/Navbar";
import setting from "../../../assets/svg/setting.svg";
import "../../common/Util.css";
import { TabGroup } from "../common/tabGroup";
import { VendorGradeList } from "../vendorGrade/vendorGradeList";
import { IndustryList } from "../Industry/industryList";
import { SubIndustryList } from "../SubIndustry/SubIndustryList";
import { ProductGroupList } from "../ProductGroup/ProductGroup";
import { ProjectStageList } from "../projectStage/projectStageList";
import { VendorStageList } from "../vendorStage/vendorStageList";
import { PaymentTypeList } from "../PaymentType/paymentTypeList";
import { CategoryList } from "../category/category-list";
import { BankList } from "../Bank/bank-list";
import { ApprovalConfigList } from "../Approval_Config/approval-list";
export const ProjectList = () => {
  const [activeTab, setActiveTab] = useState("Vendor Grade");
  const [isApprovalCreate, setIsApprovalCreate] = useState(false);
  const [selectedFlow, setSelectedFlow] = useState(null);
  const [rawSelectedFlow, setRawSelectedFlow] = useState(null);

  return (
    <>
      <div className="d-flex">
        {/* Sidebar */}
        <Sidebar currentfile="Setup" />
        {/* Main Content */}
        <div className="flex-grow-1" style={{ backgroundColor: "#F5F8FA" }}>
          <div className="" style={{ backgroundColor: "#F5F8FA" }}>
            <Navbar pageTitle="Setup" />
            <div className="p-3">
              {isApprovalCreate && activeTab === "Approval Configuration" ? (
                <ApprovalConfigList 
                  isCreateMode={isApprovalCreate} 
                  setIsApprovalCreate={setIsApprovalCreate} 
                  selectedFlow={selectedFlow}
                  setSelectedFlow={setSelectedFlow}
                  rawSelectedFlow={rawSelectedFlow}
                  setRawSelectedFlow={setRawSelectedFlow}
                />
              ) : (
                <div className="bg-white rounded-4">
                  <div className="d-flex gap-3 p-3">
                    <img src={setting} alt="settings" />
                    <div className="d-flex flex-column">
                      <p className="m-0 fs-24 fw-700">Setup</p>
                      <p className="m-0 fs-14 fw-400 textGrey">
                        Begin by setting up your masters for smooth application
                        workflow.
                      </p>
                    </div>
                  </div>
                  <div
                    className="d-flex gap-4 px-3 py-2 border-0"
                    style={{ backgroundColor: "#f9f9f9" }}
                  >
                    <TabGroup
                      currentFile={activeTab}
                      onTabChange={setActiveTab}
                    />
                  </div>

                  {activeTab === "Vendor Grade" && <VendorGradeList />}
                  {activeTab === "Industry" && <IndustryList />}
                  {activeTab === "Sub Industry" && <SubIndustryList />}
                  {activeTab === "Product Group" && <ProductGroupList />}
                  {activeTab === "Project Stage" && <ProjectStageList />}
                  {activeTab === "Vendor Stage" && <VendorStageList />}
                  {activeTab === "Payment Type" && <PaymentTypeList />}
                  {activeTab === "Category" && <CategoryList />}
                  {activeTab === "Banks" && <BankList />}
                  {activeTab === "Approval Configuration" && (
                    <ApprovalConfigList 
                      isCreateMode={false} 
                      setIsApprovalCreate={setIsApprovalCreate} 
                      selectedFlow={selectedFlow}
                      setSelectedFlow={setSelectedFlow}
                      rawSelectedFlow={rawSelectedFlow}
                      setRawSelectedFlow={setRawSelectedFlow}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
